<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Upload Positive Question Set</v-toolbar-title>
          <v-spacer />
          <div class="d-flex mr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row style="margin-top: 1rem">
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                id="questionsetname-field-validationpositivedetail"
                :label="'Question Set Name'"
                :rules="[rules.required]"
                :disabled="actionEdit"
                v-model="searchPositiveName"
                variant="outlined"
                density="comfortable"
                color="primary"
                class="modern-text-field ml-6"
                clearable
                hide-details="auto"
                :readonly="!!pId"
              >
                <template v-slot:prepend-inner>
                  <v-icon 
                    :color="pId ? 'grey-darken-1' : 'primary'" 
                    size="small"
                  >
                    {{ pId ? 'mdi-database' : 'mdi-pencil-box-outline' }}
                  </v-icon>
                </template>
                
                <template v-slot:append-inner>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        v-bind="props"
                        color="grey-darken-1"
                        size="small"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("_InfoValidationNegariveName") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-card
                v-if="uploadedFiles.length > 0"
                class="files-card"
                elevation="2"
                rounded="lg"
              >
                
                <v-virtual-scroll 
                  :items="uploadedFiles" 
                  :height="Math.min(uploadedFiles.length * 60, 120)" 
                  :item-height="60"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item class="file-item px-4 py-2">
                      <template v-slot:prepend>
                        <v-avatar size="36" color="success" class="mr-3">
                          <v-icon color="white" size="18">mdi-file-excel</v-icon>
                        </v-avatar>
                      </template>

                      <v-list-item-title class="text-subtitle-2 font-weight-medium">
                        {{ item.name }}
                      </v-list-item-title>
                      
                      <v-list-item-subtitle class="text-caption">
                        {{ formatFileSize(item.size) }}
                      </v-list-item-subtitle>

                      <template v-slot:append>
                        <v-btn 
                          @click.stop="removeFile(item.name)" 
                          icon="mdi-close"
                          size="small"
                          variant="text"
                          color="error"
                          class="ml-2"
                        />
                      </template>
                    </v-list-item>
                    <v-divider class="mx-4" v-if="uploadedFiles.indexOf(item) < uploadedFiles.length - 1" />
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              sm="12"
              md="5"
              class="d-flex justify-end align-center flex-wrap ga-3"
            >
              <!-- Template Menu -->
              <v-menu location="bottom">
                <template v-slot:activator="{ props }">
                  <v-btn
                    id="template-validationpositivedetail"
                    v-bind="props"
                    variant="outlined"
                    color="info"
                    size="small"
                    prepend-icon="mdi-file-document-outline"
                    class="template-btn"
                  >
                    Template
                  </v-btn>
                </template>
                
                <v-card min-width="200" elevation="8" rounded="lg">
                  <v-list density="compact" nav class="pa-2">
                    <v-list-item 
                      id="normalquestion-list-validationpositivedetail"
                      class="template-item" 
                      @click="normalDownload"
                      prepend-icon="mdi-file-document"
                    >
                      <v-list-item-title class="text-subtitle-2">Normal Question</v-list-item-title>
                    </v-list-item>
                    
                    <v-divider></v-divider>
                    
                    <v-list-item 
                      id="chainquestion-list-validationpositivedetail"
                      class="template-item" 
                      @click="chainTemplate"
                      prepend-icon="mdi-link-variant"
                    >
                      <v-list-item-title class="text-subtitle-2">Chain Question</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>

              <!-- Drag Drop File Component -->
              <DragDropFile
                v-if="permissions.add"
                :dialog="true"
                :DragDrop="false"
                :ShowListFile="false"
                :DropDown="true"
                :allowType="validMimeTypes_Excel"
                @uploadType="handleUploadType"
                @filesUploaded="processUpload($event)"
                class="upload-component"
              />

              <!-- Process Button -->
              <v-btn
                v-if="permissions.add"
                id="button-process-validationpositivedetail"
                color="purple-darken-1"
                variant="flat"
                size="default"
                prepend-icon="mdi-cog"
                class="process-btn"
                @click="Save()"
                :disabled="!searchPositiveName || !request.entity"
              >
                PROCESS
              </v-btn>

              <!-- Add Button -->
              <v-btn
                v-if="permissions.add"
                id="button-add-validationpositivedetail"
                color="primary"
                variant="flat"
                size="default"
                prepend-icon="mdi-plus-circle-outline"
                class="add-btn"
                @click="SetAdd()"
              >
                {{ $t("add") }}
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table-server
            class="modern-table"
            v-if="showTable == true"
            :items-per-page="itemsPerPage"
            :items-length="searchTotalTable"
            v-model:options="options"
            :items="dataTable"
            :headers="headers"
            :loading="loadingTable"
            loading-text="Loading..."
          >
            <template v-slot:item="{ item }">
              <tr>
                <td style="width: 81px; text-align: center">
                  {{ item.number }}
                </td>
                <td class="text-ellipsis">{{ item.question }}</td>
                <td class="text-ellipsis">{{ item.answer }}</td>
                <td style="text-align: center">{{ item.questionType }}</td>
                <td style="text-align: center">
                  <div class="action-group" style="justify-content: center;">
                    <!-- Edit Button -->
                    <v-btn
                      v-if="permissions.edit || permissions.view"
                      id="button-edit-popupedit-validationpositive"
                      variant="text"
                      density="comfortable"
                      @click="SetEdit(item)"
                      class="action-btn edit-btn"
                      icon
                    >
                      <v-icon size="18">{{ isViewOnly ? 'mdi-eye-outline' : 'mdi-pencil-outline' }}</v-icon>
                      <v-tooltip activator="parent" location="top">
                        {{ isViewOnly ? 'View' : 'Edit' }}
                      </v-tooltip>
                    </v-btn>

                    <!-- Action Divider -->
                    <div v-if="permissions.edit && permissions.delete" class="action-divider"></div>

                    <!-- Delete Button -->
                    <v-btn
                      v-if="permissions.delete"
                      id="button-delete-popupedit-validationpositivedetail"
                      variant="text"
                      density="comfortable"
                      @click="DeleteById(item.positiveID)"
                      class="action-btn delete-btn"
                      icon
                    >
                      <v-icon size="18">mdi-delete-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table-server>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <div class="action-banner">
                <v-card class="banner-card" elevation="1" rounded="lg">
                  <v-card-text class="banner-content">
                    <v-spacer></v-spacer>
                    
                    <!-- Delete All Button -->
                    <v-btn
                      id="button-deleteall-validationpositivedetail"
                      v-if="permissions.delete && showTable == true"
                      variant="outlined"
                      color="error"
                      size="large"
                      prepend-icon="mdi-delete-sweep"
                      @click="DeleteByName(pId)"
                      class="delete-all-btn"
                    >
                      {{ $t("deleteAll") }}
                    </v-btn>
                    
                    <!-- Back Button -->
                    <v-btn
                      id="button-back-validationpositivedetail"
                      variant="flat"
                      color="orange"
                      size="large"
                      prepend-icon="mdi-arrow-left"
                      to="/ValidationPositive"
                      class="back-btn"
                    >
                      BACK
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-flex>
      </v-card>
    </v-container>
    <!-- <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Add Dialog -->
    <v-dialog v-model="dialogAdd.flag" persistent max-width="700px" class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header Section -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon color="white" size="32">mdi-plus-circle</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">Add Question Set</h2>
              <p class="dialog-subtitle">Create a new question and answer pair</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn 
            icon 
            variant="text" 
            @click="ClearAdd"
            class="close-button"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Content Section -->
        <v-card-text class="dialog-content">
          <v-form ref="addForm" lazy-validation>
            <v-row>
              <!-- Question Field -->
              <v-col cols="12" md="6">
                <div class="field-container">
                  <v-textarea
                    :label="'Question'"
                    v-model="dialogAdd.question"
                    :rules="[rules.required]"
                    variant="outlined"
                    rows="8"
                    auto-grow
                    counter
                    color="primary"
                    class="modern-textarea"
                    hide-details="auto"
                    placeholder="Enter your question here..."
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" size="small">mdi-help-circle-outline</v-icon>
                    </template>
                  </v-textarea>
                </div>
              </v-col>

              <!-- Answer Field -->
              <v-col cols="12" md="6">
                <div class="field-container">
                  <v-textarea
                    :label="'Human Answer'"
                    v-model="dialogAdd.answer"
                    variant="outlined"
                    rows="8"
                    auto-grow
                    counter
                    color="primary"
                    class="modern-textarea"
                    hide-details="auto"
                    placeholder="Enter the expected answer here..."
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" size="small">mdi-message-text-outline</v-icon>
                    </template>
                  </v-textarea>
                </div>
              </v-col>

              <!-- Question Type -->
              <v-col cols="12">
                <div class="field-container">
                  <v-select
                    :rules="[rules.required]"
                    label="Question Type"
                    :items="questionTypeList"
                    item-title="name"
                    item-value="value"
                    variant="outlined"
                    v-model="dialogAdd.questionType"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    hide-details="auto"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" size="small">mdi-format-list-bulleted-type</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon 
                            v-bind="props"
                            color="grey-darken-1"
                            size="small"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Select the type of question: Normal or Chain</span>
                      </v-tooltip>
                    </template>
                  </v-select>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Actions Section -->
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            variant="outlined"
            color="grey"
            size="large"
            @click="ClearAdd"
            class="dialog-action-btn cancel-btn"
            prepend-icon="mdi-close"
          >
            {{ $t("close") }}
          </v-btn>
          <v-btn
            v-if="permissions.add"
            variant="flat"
            size="large"
            @click="Add"
            class="dialog-action-btn save-btn-add"
            prepend-icon="mdi-content-save"
          >
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog -->
    <v-dialog v-model="dialogEdit.flag" persistent max-width="700px" class="modern-dialog">
      <v-card class="dialog-card" elevation="8">
        <!-- Header Section -->
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon color="white" size="32">mdi-pencil</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">Edit Question Set</h2>
              <p class="dialog-subtitle">Modify the existing question and answer pair</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn 
            icon 
            variant="text" 
            @click="ClearEdit"
            class="close-button"
            color="white"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Content Section -->
        <v-card-text class="dialog-content">
          <v-form ref="editForm" lazy-validation>
            <v-row>
              <!-- Question Field -->
              <v-col cols="12" md="6">
                <div class="field-container">
                  <v-textarea
                    :label="'Question'"
                    v-model="dialogEdit.question"
                    :rules="[rules.required]"
                    variant="outlined"
                    rows="8"
                    auto-grow
                    counter
                    color="primary"
                    class="modern-textarea"
                    hide-details="auto"
                    placeholder="Enter your question here..."
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" size="small">mdi-help-circle-outline</v-icon>
                    </template>
                  </v-textarea>
                </div>
              </v-col>

              <!-- Answer Field -->
              <v-col cols="12" md="6">
                <div class="field-container">
                  <v-textarea
                    :label="'Human Answer'"
                    v-model="dialogEdit.answer"
                    variant="outlined"
                    rows="8"
                    auto-grow
                    counter
                    color="primary"
                    class="modern-textarea"
                    hide-details="auto"
                    placeholder="Enter the expected answer here..."
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" size="small">mdi-message-text-outline</v-icon>
                    </template>
                  </v-textarea>
                </div>
              </v-col>

              <!-- Question Type -->
              <v-col cols="12">
                <div class="field-container">
                  <v-select
                    :rules="[rules.required]"
                    label="Question Type"
                    :items="questionTypeList"
                    item-title="name"
                    item-value="value"
                    variant="outlined"
                    v-model="dialogEdit.questionType"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    hide-details="auto"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" size="small">mdi-format-list-bulleted-type</v-icon>
                    </template>
                  </v-select>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Actions Section -->
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            variant="outlined"
            color="grey"
            size="large"
            @click="ClearEdit"
            class="dialog-action-btn cancel-btn"
            prepend-icon="mdi-close"
          >
            {{ $t("close") }}
          </v-btn>
          <v-btn
            v-if="permissions.edit"
            variant="flat"
            size="large"
            @click="EditById"
            class="dialog-action-btn save-btn-edit"
            prepend-icon="mdi-content-save"
          >
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DragDropFile from "@/components/DragDropFile.vue";
import ExcelJS from "exceljs";

export default {
  name: "ValidationPositiveDetail",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: { DragDropFile },
  props: ["id"],
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ValidationPositive');
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('ValidationPositive'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('ValidationPositive'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('ValidationPositive'),
      }
    },
  },
  data: () => ({
    isInitialized: false,
    uploadDialog: false,
    checkbox1: false,
    actionEdit: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    loadingDownload: true,
    today: null,
    searchPositiveName: null,
    pId: null,
    request: {
      name: null,
      entity: null,
      type: "",
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    files: [],
    dataTable: [],
    uploadedFiles: [],
    headers: [],
    isSearch: false,
    isFirst: true,
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    showTable: false,
    dataUpdate: 0,
    dataAll: 0,
    exceptionFlag: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    sortBy: [],
    sortDesc: [],
    questionType: "",
    dialogAdd: {
      flag: false,
      id: null,
      question: "",
      answer: "",
      questionType: "",
    },
    dialogEdit: {
      flag: false,
      id: null,
      question: "",
      answer: "",
      questionType: "",
    },
    questionTypeList: [
      { name: "Normal Question", value: "Normal Question" },
      { name: "Chain Question", value: "Chain Question" },
    ],
    validMimeTypes_Excel: [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel", // .xls
    ],
  }),
  watch: {
    options: {
      handler() {
        if(!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },
  },
  methods: {
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    Get() {
      let self = this;
      self.loadingTable = true;
      self.dialog = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.pId,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableValidationPositiveDetail(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if(dataResponse.data == undefined || dataResponse.data == null) {
              self.dataTable = [];
              self.searchTotalTable = 0;
              self.totalTable = 0;
            }
            else 
            {
              self.searchTotalTable = dataResponse.data.total;
              self.dataTable = dataResponse.data.data;
              if (
                dataResponse.data.data != undefined &&
                dataResponse.data.data != null &&
                dataResponse.data.data.length > 0
              ) {
                self.searchPositiveName = dataResponse.data.data[0].name;
              }
              self.dataTable.forEach((element) => {
                element.questionType = element.questionType == "P" ? "Positive" : "Chain";
              });
              self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
          self.showTable = true;
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    handleUploadType(type) {
      this.request.type = type;
    },
    Save() {
      let self = this;
      if (!self.searchPositiveName || !self.request.entity) {
        self.$swal.fire({
          icon: "warning",
          title: "Please Fill All The Fields!",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      } else {
        self.showTable = false;
        self.request.name = self.searchPositiveName;
        self.dialog = true;
        try {
          self.$call.UploadValidationPositive(
            self.request,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.isFirst = true;
                self.showTable = true;
                self.pId = dataResponse.data;
                self.searchPositiveName = self.request.name;
                self.request.entity = null;
                self.uploadedFiles = [];
                if (self.$route.query.id !== String(self.pId)) {
                  window.location.href = `${self.$route.path}?id=${self.pId}`;
                }
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } catch (error) {
          this.LogTrace(error, "DeleteGroup");
        }
      }
    },
    processUpload(e) {
        this.files = e;
        if (this.files.length == 0) {
          this.request.entity = null;
          this.uploadedFiles = [];
          return;
        }
        const reader = new FileReader();
        reader.readAsText(this.files[0]);
        reader.onload = () => {
        let text = reader.result;
        this.ValidateCSV(text, this.files);
      };
    },
    ValidateCSV(csv, files) {
      // let temp = csv.replaceAll('\r', '');
      // let lines = temp.split('\n');
      // let counter = 0;
      // Early exit if the first line is not 'Questions'
      // if (lines[0] !== 'Questions') {
      //   alert(`${this.request.type} first column must name "Questions"!`);
      //   return;
      // }
      // lines.forEach(element => {
      //   if(element.slice(0,5).includes("#End#")){
      //     counter++
      //   }
      // });
      // if (this.request.type === "Chain Question" && counter === 0) {
      //   alert('Chain Question format is incorrect!');
      // } else if (this.request.type === "Normal Question" && counter >= 1 ) {
      //   alert('Normal Question format is incorrect!');
      // } else {
      //   const formDataDoc = new FormData();
      //   formDataDoc.append('entity', files[0]);
      //   this.uploadedFiles = files;
      //   this.request.entity = formDataDoc;
      // }
      const formFile = new FormData();
      formFile.append("formFile", files[0]);
      this.$call.ValidateCSV(
        formFile,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            console.log(dataResponse.data);
            if (!dataResponse.data) {
              this.uploadedFiles = [];
              this.request.entity = null;
              this.$swal.fire({
                icon: "warning",
                title: "Invalid file format!",
                text: "Please ensure the file is in the correct format.",
                showConfirmButton: false,
                timer: 2500,
              });
            }else {
              const formDataDoc = new FormData();
              formDataDoc.append("entity", files[0]);
              this.uploadedFiles = files;
              this.request.entity = formDataDoc;
              this.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          } 
        },
      );
      
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName);
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit("filesUploaded", this.uploadedFiles);
    },
    SetAdd() {
      let self = this;
      self.dialogAdd.flag = true;
      self.dialogAdd.question = "";
      self.dialogAdd.answer = "";
      self.dialogAdd.questionType = "";
    },
    ClearAdd() {
      let self = this;
      self.dialogAdd.flag = false;
      self.dialogAdd.question = "";
      self.dialogAdd.answer = "";
      self.dialogAdd.questionType = "";
    },
    Add() {
      let self = this;
      try {
        if (self.dialogAdd.question == "") {
          self.dialogAdd.flag = false;
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("_Please_Question"),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        } else if (self.dialogAdd.questionType == "") {
          self.dialogAdd.flag = false;
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: "Please specify your question type.",
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        } else if (!self.searchPositiveName) {
          self.dialogAdd.flag = false;
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: "Please Fill All The Fields!",
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        } else {
          self.dialog = true;
          self.showTable = false;
          self.request.name = self.searchPositiveName;
          var temp = {
            name: self.pId == null ? self.searchPositiveName : self.pId,
            question: self.dialogAdd.question,
            answer: self.dialogAdd.answer,
            questionType: self.dialogAdd.questionType,
          };
          self.$call.AddValidationPositiveDetail(
            temp,
            (dataResponse) => {
              self.dialog = false;
              if (dataResponse.status == 0) {
                self.isFirst = true;
                self.showTable = true;
                self.pId = dataResponse.data;
                self.searchPositiveName = self.request.name;
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  self.ClearAdd();

                  self.$router.replace({
                    query: { id: self.pId },
                  });
                });
                
              }
              
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "Add Positive Question");
      }
    },
    SetEdit(item) {
      let self = this;
      self.dialogEdit.flag = true;
      self.dialogEdit.id = item.positiveID;
      self.dialogEdit.question = item.question;
      self.dialogEdit.answer = item.answer;
      self.dialogEdit.questionType =
        item.questionType == "Positive" ? "Normal Question" : "Chain Question";
    },
    ClearEdit() {
      let self = this;
      self.dialogEdit.flag = false;
      self.dialogEdit.id = null;
      self.dialogEdit.question = "";
      self.dialogEdit.answer = "";
    },
    EditById() {
      let self = this;
      try {
        if (self.dialogEdit.question == "") {
          self.dialogEdit.flag = false;
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("_Please_Question"),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        } else if (self.dialogEdit.questionType == "") {
          self.dialogEdit.flag = false;
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: "Please specify your question type.",
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        } else {
          self.dialog = true;
          var temp = {
            positiveID: self.dialogEdit.id,
            question: self.dialogEdit.question,
            answer: self.dialogEdit.answer,
            questionType: self.dialogEdit.questionType,
          };
          self.$call.EditValidationPositiveDetail(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.ClearEdit();
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "Edit Positive Question");
      }
    },
    DeleteById(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionQuestion"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteValidationPositiveDetail(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Get();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    DeleteByName(name) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionAllQuestion"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteValidationPositive(
                name,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Clear();
                  }
                  self.dialog = false;
                  this.$router.push("/ValidationPositive");
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Clear() {
      let self = this;
      self.showTable = false;

      self.request.entity = null;
      self.request.name = null;
      self.request.type = null;
      self.searchPositiveName = null;
      self.dataTable = [];
      self.searchTotalTable = 0;
      self.totalTable = 0;

      this.$emit("back", true);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    async normalDownload() {
      const data = [
        {
          Questions: "จังหวัดที่อยู่เหนือสุดของประเทศไทย",
          "Human Answer": "จังหวัดที่อยู่เหนือสุดของประเทศไทยคือจังหวัดเชียงราย",
        },
        {
          Questions: "จังหวัดที่อยู่ใต้สุดของประเทศไทย",
          "Human Answer": "จังหวัดที่อยู่ใต้สุดของประเทศไทยคือจังหวัดยะลา",
        },
        {
          Questions: "จังหวัดที่มีพื้นที่มากที่สุดของประเทศไทย",
          "Human Answer": "จังหวัดที่มีพื้นที่มากที่สุดของประเทศไทยคือจังหวัดเชียงใหม่",
        },
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 30 },
        { header: "Human Answer", key: "Human Answer", width: 50 },
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "upload_questions.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
    async chainTemplate() {
      const data = [
        {
          Questions: "จังหวัดที่อยู่เหนือสุดของประเทศไทยคือจังหวัดอะไร?",
          "Human Answer": "จังหวัดที่อยู่เหนือสุดของประเทศไทยคือจังหวัดเชียงราย",
        },
        {
          Questions: "ทำไมจังหวัดเชียงรายจึงเป็นจังหวัดที่อยู่เหนือสุดของประเทศไทย?",
          "Human Answer":
            "จังหวัดเชียงรายเป็นจังหวัดที่อยู่เหนือสุดของประเทศไทย เนื่องจากพื้นที่ของอำเภอแม่สายมีพิกัดเหนือสุดของประเทศ และมีพรมแดนติดกับประเทศเมียนมา",
        },
        {
          Questions: "จังหวัดเชียงรายมีความสำคัญทางประวัติศาสตร์และเศรษฐกิจอย่างไร?",
          "Human Answer":
            "จังหวัดเชียงรายมีความสำคัญทางประวัติศาสตร์เพราะเคยเป็นศูนย์กลางของอาณาจักรล้านนา และเป็นจุดกำเนิดของเมืองเชียงใหม่ นอกจากนี้ ยังเป็นศูนย์กลางเศรษฐกิจของภาคเหนือ มีแหล่งท่องเที่ยวสำคัญ เช่น ดอยแม่สลอง วัดร่องขุ่น และเป็นศูนย์กลางการค้าชายแดนไทย-เมียนมา",
        },
        { Questions: "#End#", "Human Answer": "#End#" },
        {
          Questions: "วิธีทำไข่เจียวแบบง่ายๆ ต้องใช้อะไรบ้าง?",
          "Human Answer":
            "การทำไข่เจียวแบบง่ายๆ ใช้ไข่ไก่ 2 ฟอง น้ำปลา 1 ช้อนชา น้ำมันสำหรับทอด และอาจเติมต้นหอมซอยหรือหอมแดงเพื่อเพิ่มรสชาติ",
        },
        {
          Questions: "ทำอย่างไรให้ไข่เจียวฟูและกรอบนอกนุ่มใน?",
          "Human Answer":
            "เพื่อให้ไข่เจียวฟูและกรอบนอกนุ่มใน ควรตีไข่ให้ขึ้นฟองอากาศก่อนทอด ใช้น้ำมันร้อนจัด และทอดในน้ำมันที่มีปริมาณมากพอให้ไข่ลอยตัว อีกทั้งสามารถเติมน้ำเย็นหรือน้ำโซดาลงไปเล็กน้อยขณะตีไข่เพื่อเพิ่มความฟู",
        },
        {
          Questions: "กระบวนการทางวิทยาศาสตร์ที่ทำให้ไข่เจียวฟูมีอะไรบ้าง?",
          "Human Answer":
            "ไข่เจียวฟูเกิดจากการดักจับฟองอากาศในไข่ขณะตี เมื่อเจอกับความร้อน อากาศที่ติดอยู่ขยายตัว ทำให้ไข่เจียวพองขึ้น นอกจากนี้ โปรตีนในไข่ขาวจะเกิดการ Denaturation (การเปลี่ยนแปลงโครงสร้างของโปรตีน) และ Coagulation (การแข็งตัวของโปรตีน) ทำให้ไข่เซ็ตตัวและรักษารูปทรงฟูไว้",
        },
        { Questions: "#End#", "Human Answer": "#End#" },
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 50 },
        { header: "Human Answer", key: "Human Answer", width: 70 },
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" },
      };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Chain_template.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
  },
  mounted() {
    this.GetDate();
    this.headers = [
      {
        title: this.$t("no"),
        align: "center",
        sortable: false,
      },
      { title: "Question", align: "left", sortable: true, value: "Question" },
      { title: "Human Answer", align: "left", sortable: true, value: "Answer" },
      { title: "Type", align: "center", sortable: true, value: "questionType" },
      { title: this.$t("action"), align: "center", sortable: false, width: "150px" },
    ];
    if (this.$route.query.id) {
      this.searchPositiveName = this.$route.query.id;
      this.pId = this.$route.query.id;
      this.showTable = true;
      this.actionEdit = true;
    }
    this.Get();
    this.isInitialized = true;
  },
};
</script>
<style scoped>
/* =============================================================================
   MAIN LAYOUT STYLES
   ============================================================================= */
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.text-ellipsis {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* =============================================================================
   MODERN TEXT FIELD STYLES
   ============================================================================= */
.modern-text-field {
  margin-top: 8px;
}

.modern-text-field :deep(.v-field) {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-text-field:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Read-only state */
.modern-text-field :deep(.v-field--readonly) {
  background: #f8f9fa !important;
  opacity: 0.9;
}

.modern-text-field :deep(.v-field--readonly .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.08) !important;
  border-style: dashed !important;
}

.modern-text-field :deep(.v-field--readonly:hover .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

/* Label styling */
.modern-text-field :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-text-field :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-text-field :deep(.v-field--readonly .v-label) {
  color: #6c757d !important;
}

/* Input text styling */
.modern-text-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-text-field :deep(.v-field--readonly .v-field__input) {
  color: #6c757d !important;
}

.modern-text-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

/* Icon styling */
.modern-text-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-text-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* =============================================================================
   FILES DISPLAY STYLES
   ============================================================================= */
.files-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  transition: all 0.2s ease;
}

.files-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.3);
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08);
}

.files-card .v-card-title {
  background: rgba(var(--v-theme-surface-variant), 0.3);
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.file-item {
  transition: background-color 0.2s ease;
}

.file-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

.file-item .v-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
}

/* Custom scrollbar */
.v-virtual-scroll::-webkit-scrollbar {
  width: 4px;
}

.v-virtual-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.v-virtual-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(var(--v-theme-on-surface), 0.2);
  border-radius: 2px;
}

.v-virtual-scroll::-webkit-scrollbar-thumb:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.3);
}

/* =============================================================================
   BUTTON STYLES
   ============================================================================= */
.template-btn {
  text-transform: none;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.template-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.3);
}

.template-item {
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
  margin: 2px 4px;
}

.template-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.08);
  transform: translateX(4px);
}

.process-btn {
  background: linear-gradient(135deg, #9747ff 0%, #7c3aed 100%);
  border-radius: 25px;
  min-width: 100px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(151, 71, 255, 0.3);
}

.process-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(151, 71, 255, 0.4);
}

.process-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.add-btn {
  border-radius: 12px;
  font-weight: 600;
  text-transform: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(var(--v-theme-primary), 0.3);
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(var(--v-theme-primary), 0.4);
}

/* =============================================================================
   DATA TABLE STYLES
   ============================================================================= */
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/* =============================================================================
   DIALOG STYLES
   ============================================================================= */
.modern-dialog {
  margin: 24px;
  animation: dialogSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2) !important;
}

/* Dialog Header */
/* .dialog-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  padding: 24px !important;
  position: relative;
  border-bottom: none !important;
}

.header-icon-container {
  background: rgba(25, 118, 210, 0.1);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.header-text {
  flex: 1;
}
*/
/* .dialog-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
}

.dialog-subtitle {
  font-size: 0.875rem !important;
  color: #6c757d !important;
  margin: 0 !important;
  font-weight: 400 !important;
} */
/*
.close-btn {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 50% !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  transform: scale(1.1) !important;
} */

/* Dialog Content */
.dialog-content {
  padding: 32px 24px !important;
  background: #ffffff;
}

.field-container {
  margin-bottom: 16px;
}

/* Modern field and textarea shared styles */
.modern-field :deep(.v-field__outline),
.modern-textarea :deep(.v-field__outline) {
  border-radius: 12px !important;
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field--focused .v-field__outline),
.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-field :deep(.v-field),
.modern-textarea :deep(.v-field) {
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-field:hover :deep(.v-field__outline),
.modern-textarea:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-field :deep(.v-label),
.modern-textarea :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-field :deep(.v-field--focused .v-label),
.modern-textarea :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-field :deep(.v-field__input),
.modern-textarea :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-field :deep(.v-field__input::placeholder),
.modern-textarea :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

.modern-field :deep(.v-field__prepend-inner),
.modern-textarea :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-field :deep(.v-field__append-inner),
.modern-textarea :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* Dialog Actions */
/* .dialog-actions {
  background: rgba(248, 249, 250, 0.5) !important;
  padding: 20px 24px !important;
  gap: 12px;
}

.cancel-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  border-color: #dee2e6 !important;
  color: #6c757d !important;
}

.cancel-btn:hover {
  background: #f8f9fa !important;
  border-color: #adb5bd !important;
  color: #495057 !important;
}

.save-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.save-edit-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(255, 164, 7, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-edit-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(255, 164, 7, 0.4) !important;
} */

/* =============================================================================
   ACTION BANNER STYLES
   ============================================================================= */
.action-banner {
  margin: 24px 0 16px 0;
  padding: 0 8px;
}

.banner-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
  border: 1px solid rgba(var(--v-theme-on-surface), 0.08) !important;
  transition: all 0.3s ease;
}

.banner-card:hover {
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08) !important;
}

.banner-content {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 16px !important;
  padding: 16px 24px !important;
  min-height: 60px;
}

.delete-all-btn {
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 140px !important;
  border-width: 2px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.delete-all-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.08) !important;
  border-color: rgb(var(--v-theme-error)) !important;
  transform: translateY(-2px) !important;
}

.delete-all-btn:active {
  transform: translateY(0) !important;
}

.back-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%) !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  color: white !important;
}

.back-btn:hover {
  background: linear-gradient(135deg, #f57c00 0%, #e65100 100%) !important;
  transform: translateY(-2px) !important;
}

.back-btn .v-icon {
  color: white !important;
}

/* Enhanced hover states for banner buttons */
.delete-all-btn .v-icon,
.back-btn .v-icon {
  transition: transform 0.2s ease !important;
}

.delete-all-btn:hover .v-icon {
  transform: scale(1.1) rotate(-5deg) !important;
}

.back-btn:hover .v-icon {
  transform: scale(1.1) translateX(-2px) !important;
}

/* =============================================================================
   ANIMATIONS
   ============================================================================= */
@keyframes dialogSlideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 960px) {
  .d-flex.justify-end {
    justify-content: center !important;
  }
  
  .process-btn,
  .add-btn {
    min-width: 120px;
  }
}

@media (max-width: 768px) {
  /* Action Banner */
  .action-banner {
    margin: 16px 0 12px 0;
    padding: 0 4px;
  }
  
  .banner-content {
    padding: 12px 16px !important;
    gap: 12px !important;
    flex-direction: column-reverse !important;
    align-items: stretch !important;
  }
  
  .delete-all-btn,
  .back-btn {
    width: 100% !important;
    min-width: auto !important;
    justify-content: center !important;
  }
  
  .delete-all-btn {
    order: 2;
  }
  
  .back-btn {
    order: 1;
  }

  /* Dialog Responsive */
  .dialog-header {
    padding: 20px 16px !important;
  }
  
  .header-icon-container {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }
  
  .dialog-title {
    font-size: 1.25rem !important;
  }
  
  .dialog-content {
    padding: 24px 16px !important;
  }
  
  .dialog-actions {
    padding: 16px !important;
    flex-direction: column;
  }
  
  .cancel-btn,
  .save-btn,
  .save-edit-btn {
    width: 100% !important;
    min-width: auto !important;
  }

  .modern-field :deep(.v-field__input),
  .modern-textarea :deep(.v-field__input) {
    font-size: 0.9rem !important;
    padding: 14px 10px !important;
  }
  
  .modern-field :deep(.v-label),
  .modern-textarea :deep(.v-label) {
    font-size: 0.8rem !important;
  }
}

@media (max-width: 600px) {
  .ga-3 {
    gap: 0.5rem !important;
  }
  
  .process-btn,
  .add-btn {
    font-size: 0.875rem;
    min-width: 100px;
  }

  .banner-content {
    gap: 8px !important;
  }
  
  .delete-all-btn,
  .back-btn {
    font-size: 0.875rem !important;
    padding: 12px 16px !important;
  }
  
  .back-btn {
    letter-spacing: 0.5px !important;
  }
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-x: auto;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead) {
  position: sticky;
  top: 0;
  z-index: 2;
}

.modern-table :deep(.v-table__wrapper thead th) {
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
  height: 8px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
